<template>
  <form class="form">
    <h2>Диссертация</h2>

    <fieldset class="form form--fieldset" disabled>
      <div class="form__group">
        <t-text :model-value="store.application.dissertation?.chair || 'Не указано'" label="Кафедра"/>
        <div class="form__spacer"></div>
        <div class="form__spacer"></div>
      </div>

      <div class="form__group">
        <t-textarea :model-value="store.application.dissertation?.theme || 'Не указано'" label="Предполагаемая тема диссертации"/>
      </div>
    </fieldset>

    <hr>

    <h2>Научный руководитель</h2>

    <fieldset class="form form--fieldset" disabled>
      <div class="form__group">
        <t-text :model-value="store.application.dissertation?.scientific_supervisor || 'Не указано'" label="Научный руководитель"/>
        <div class="form__spacer"></div>
        <div class="form__spacer"></div>
      </div>

      <div class="form__group">
        <t-textarea :model-value="store.application.dissertation?.conclusion || 'Не указано'" label="Заключение научного руководителя о результате собеседования"/>
      </div>
    </fieldset>
  </form>
</template>

<script setup>
import { TText, TTextarea } from '@shared/ui'
import { useApplicationStore } from '@widgets/application-profile'

defineProps({
  readonly: { type: Boolean, default: false },
})

const store = useApplicationStore()
</script>
